import React from 'react'
import { storiesOf } from '@storybook/react'

import { PlayerPosition } from '../protos/index'

import VitalStatistics from 'components/VitalStatistics'

storiesOf('VitalStatistics', module)
  .add('default', () => (
    <VitalStatistics />
  ))
  .add('with data', () => (
    <VitalStatistics
      topTeamScore={{
        score: 745,
        match: {
          kickoff: Math.round(Date.now() / 1000),
          homeTeam: { name: 'Manchester United' },
          awayTeam: { name: 'Ferencváros TC' }
        },
      }}
      topPlayerScore={{
        player: {
          name: 'Varga Roland',
          jersey: {
            baseColor: '00BB00',
            sleeveColor: 'FFFFFF',
            numberColor: 'FFFFFF',
            jerseyNumber: '97',
          },
          position: PlayerPosition.PP_ATTACKER,
          team: {
            name: 'Ferencváros TC',
          },
        },
      }}
    />
  ))
